export const MAP_MODAL_DATA = {
  modalStyles: {
    width: '100%',
    maxWidth: '100vw',
    // dvh (not vh) so mobile browser chrome doesn't make the paper taller
    // than the visible viewport, which was pushing the header/close button
    // above the fold.
    height: 'calc(100dvh - 32px)',
    maxHeight: 'calc(100dvh - 32px)',
    m: 0,
    borderRadius: '16px',
    overflow: 'hidden',
    '@media (min-width:1440px)': {
      width: '1680px',
      maxWidth: '1680px',
      height: 'calc(100vh - 90px)',
      maxHeight: '938px',
      borderRadius: '16.46px',
    },
  },
  dialogSx: {
    '& .MuiDialog-container': {
      alignItems: 'flex-start',
    },
    '@media (min-width:1440px)': {
      top: '70px',
      left: '120px',
    },
  },
};

export const MYKONOS_BOUNDS = {
  north: 37.505,
  south: 37.385,
  east: 25.485,
  west: 25.285,
};

export const MYKONOS_VIEW_BOUNDS = {
  north: 37.525,
  south: 37.365,
  east: 25.515,
  west: 25.255,
};

export const MYKONOS_MAP_RESTRICTION = {
  latLngBounds: MYKONOS_VIEW_BOUNDS,
  strictBounds: true,
};

export const isInMykonosBounds = (lat: number, lng: number) =>
  lat >= MYKONOS_BOUNDS.south &&
  lat <= MYKONOS_BOUNDS.north &&
  lng >= MYKONOS_BOUNDS.west &&
  lng <= MYKONOS_BOUNDS.east;
